import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

/** Presentation only: the page and saved-day browser retain ownership of evidence. */
export function ReportingDataDetails({ children }: { children: ReactNode }) {
  return <Dialog>
    <DialogTrigger asChild>
      <Button variant="outline" size="sm" className="h-8 shrink-0 rounded-full text-xs">Data details</Button>
    </DialogTrigger>
    <DialogContent className="max-h-[85dvh] w-[calc(100%-2rem)] max-w-2xl overflow-y-auto break-words">
      <DialogHeader>
        <DialogTitle>Data details</DialogTitle>
        <DialogDescription>Saved reporting evidence for the selected account and dates. Collection age is not provider freshness or current delivery confirmation.</DialogDescription>
      </DialogHeader>
      <div className="min-w-0 space-y-5 text-sm">{children}</div>
    </DialogContent>
  </Dialog>;
}

export function ReportingDetail({ label, children }: { label: string; children: ReactNode }) {
  return <div className="min-w-0 space-y-1">
    <dt className="font-medium text-foreground">{label}</dt>
    <dd className="m-0 text-muted-foreground">{children}</dd>
  </div>;
}
